import { render, staticRenderFns } from "./HorizontalTab.vue?vue&type=template&id=1f78a79c&"
import script from "./HorizontalTab.vue?vue&type=script&lang=js&"
export * from "./HorizontalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports